import { FC } from 'react';
import { DialogProps } from '@toolpad/core/useDialogs';
import {
  Dialog,
  DialogContent,
  Stack,
  Button,
  Typography,
} from '@mui/material';

import { useGetSpacing } from '@ui';

type Props = {
  okText: string;
  cancelText: string;
  text: string;
};

export const ConfirmDialog: FC<DialogProps<Props, string | null>> = ({
  payload,
  open,
  onClose,
}) => {
  const getSpacing = useGetSpacing();

  const handleConfirm = async () => {
    onClose('confirmed');
  };

  const handleCancel = async () => {
    onClose('cancelled');
  };

  return (
    <>
      <Dialog open={open}>
        <DialogContent>
          <Stack direction="column" spacing={getSpacing('l')}>
            <Typography
              sx={{ fontSize: 18, fontWeight: 400, textAlign: 'center' }}
            >
              {payload.text}
            </Typography>
            <Button onClick={handleConfirm} variant="contained" color="primary">
              {payload.okText}
            </Button>
            <Button onClick={handleCancel} color="secondary">
              {payload.cancelText}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};
